import React from 'react';
import { MySubscriptions } from './MySubscriptions';
import { ProfileForm } from './ProfileForm';
import { DisplaySettings } from './DisplaySettings';
import { BaseLayout } from '@/components/layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

export const AccountSettings: React.FC = () => {
  return (
    <BaseLayout>
      <div className="min-h-screen bg-background pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground">My Account</h1>
            <p className="text-muted-foreground mt-2">
              Manage your profile and subscriptions
            </p>
          </div>

          {/* Vertical Tabs Layout */}
          <Tabs defaultValue="profile" className="w-full">
            <div className="grid grid-cols-12 gap-6">
              {/* Left Sidebar with Tabs */}
              <div className="col-span-12 lg:col-span-3">
                <div className="bg-card rounded-lg shadow-sm border border-border p-2">
                  <TabsList className="flex flex-col h-auto w-full bg-transparent space-y-1">
                    <TabsTrigger 
                      value="profile"
                      className="w-full justify-start px-4 py-3 data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-none"
                    >
                      Profile
                    </TabsTrigger>
                    <TabsTrigger 
                      value="display"
                      className="w-full justify-start px-4 py-3 data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-none"
                    >
                      Display
                    </TabsTrigger>
                    <TabsTrigger 
                      value="subscriptions"
                      className="w-full justify-start px-4 py-3 data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-none"
                    >
                      My Subscriptions
                    </TabsTrigger>
                  </TabsList>
                </div>
              </div>

              {/* Right Content Area */}
              <div className="col-span-12 lg:col-span-9">
                <TabsContent value="profile" className="mt-0">
                  <ProfileForm />
                </TabsContent>
                <TabsContent value="display" className="mt-0">
                  <DisplaySettings />
                </TabsContent>
                <TabsContent value="subscriptions" className="mt-0">
                  <MySubscriptions />
                </TabsContent>
              </div>
            </div>
          </Tabs>
        </div>
      </div>
    </BaseLayout>
  );
};

